export enum UserAuthenticationStatus {
  Invalid = 0,
  NotLoggedIn,
  LoggedIn,
  OtherDeviceLoggedIn,
}

export interface AccountProvider {
  getAnonymousAccount(): Promise<AccountService>;
  logIn(loginInfo: LoginInfo): Promise<AccountService>;
}

export interface LogInCredentials {
  username: string;
  password: string;
}

export const isLoginCredentials = (
  info: LoginInfo
): info is LogInCredentials => {
  return !!(info as LogInCredentials).username;
};

export interface AuthToken {
  authToken: string;
}

export const isAuthToken = (info: LoginInfo): info is AuthToken => {
  return !!(info as AuthToken).authToken;
};

export type LoginInfo = LogInCredentials | AuthToken;

export interface AccountService {
  contacts?: ContactsService;
  messages?: MessagesService;
  callHistory?: CallHistoryService;

  // Different UI flags
  hasDialPad?: boolean;

  authToken?: unknown;
}

export interface ContactPhoneNumber {
  Id: number;
  PublicId: string;
  PhoneNumberType: string;
  DialType: number;
  DialString: string | number;
}

export interface ContactsService {
  contacts?: CallListItem[];
}

export interface Message {
  uri: string;
  name: string;
  time: Date;
}

export interface MessageListItem {
  ItemId?: number;
  DialType: number;
  DialString: string | number;
  Name: string;
  PlaybackTime?: number;
  MessageLength?: number;
  FileSize?: number;
  Time?: string;
  Viewed?: boolean;
  MessageType?: number;
  MessageTypeId?: number;
  InterpreterId?: string;
  ImageId?: string;
  PreviewImageDownloadUrl?: string;
  IsFeaturedVideo?: boolean;
  FeaturedVideoPosition?: number;
  AirDate?: string;
  ExpireDate?: string;
  Description?: string;
}

export interface MessagesService {
  messageItems?: MessageListItem[];
  // removeMessage(message: Message): Promise<void>
}

export interface CallListItem {
  CompanyName?: string;
  DialType?: number;
  DialString?: string;
  ImageDate?: string;
  ImagePublicId?: string;
  InAddressBook?: string;
  ItemId?: number;
  Name?: string;
  PublicId?: string;
  Rejected?: string;
  RelayLanguage?: string;
  RingColor?: number;
  RingTone?: number;
  Time?: string;
  UserType?: string;
  ContactPhoneNumberList?: ContactPhoneNumber;
}

export interface CallHistoryService {
  callHistoryItems?: CallListItem[];
}
